import { ReactComponent as IconDownload } from '../ContractItem/img/iconDownload.svg';
import styles from './ReferenceActions.module.scss';
import { WorkerReference } from 'redux/Api/referencesApi/type';
import { useState } from 'react';
import { getFileNameFromContentDisposition } from 'utils/strActions';
import { REFERENCE_MODAL_MESSAGES } from 'pages/EmployedsProfileContent/EmployedsProfileContentDesktop';

const getAuthorizationHeader = () => {
  const token = localStorage.getItem('token');
  return token ? `Bearer ${token}` : '';
};

export interface ReferenceActionsContentProps {
  reference: WorkerReference;
  workerId?: string;
  onItemClick: () => void;
  onShowError: (content: { title: string; text: string }) => void;
}

export const ReferenceActionsContent: React.FC<ReferenceActionsContentProps> = ({
  reference,
  workerId,
  onItemClick,
  onShowError,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!workerId) {
      console.error('Worker ID is required for download');
      return;
    }

    if (isDownloading) return;

    setIsDownloading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/docs/registration-reference/${workerId}`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            Authorization: getAuthorizationHeader(),
          },
        },
      );

      if (response.ok) {
        const type = response.headers.get('content-type') || undefined;
        const disposition = response.headers.get('content-disposition');
        const arrayBuffer = await response.blob();

        const blob = new Blob([arrayBuffer], { type });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          getFileNameFromContentDisposition(disposition) ||
            `${reference.name || 'reference'}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        onItemClick();
      } else {
        onShowError(REFERENCE_MODAL_MESSAGES.ERROR_DOWNLOAD_REFERENCE);
        onItemClick();
      }
    } catch (error) {
      onShowError(REFERENCE_MODAL_MESSAGES.ERROR_DOWNLOAD_REFERENCE);
      onItemClick();
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div
      className={styles.item}
      onClick={handleDownload}
      style={{
        opacity: isDownloading ? 0.6 : 1,
        cursor: isDownloading ? 'not-allowed' : 'pointer',
        pointerEvents: isDownloading ? 'none' : 'auto',
      }}>
      <IconDownload />
      <span>{isDownloading ? 'Загрузка...' : 'Скачать справку'}</span>
    </div>
  );
};
